import { createFileRoute } from '@tanstack/react-router'
import RegistrationForm from '../RegistrationForm'
import styles from '../App.module.css'

export const Route = createFileRoute('/register')({
  component: RegisterPage
})

function RegisterPage() {
  return (
    <section className={styles.register}>
      <div className={styles.container}>
        <div className={styles.registerCard}>
          <RegistrationForm />
        </div>
      </div>
    </section>
  )
}
